import { render, staticRenderFns } from "./LatestContainer.vue?vue&type=template&id=6ac2c5aa&scoped=true&"
import script from "./LatestContainer.vue?vue&type=script&lang=js&"
export * from "./LatestContainer.vue?vue&type=script&lang=js&"
import style0 from "./LatestContainer.vue?vue&type=style&index=0&id=6ac2c5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2c5aa",
  null
  
)

export default component.exports